import { motion } from "framer-motion";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Link } from "react-router-dom";
import { Lock, Zap, Crown, Flame, CheckCircle } from "lucide-react";

export default function SubscriptionPaywall({ trialDaysLeft = 0, trialExpired = true }) {
  return (
    <div className="fixed inset-0 z-[100] bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-lg"
      >
        <Card className="bg-card border-primary/30">
          <CardContent className="p-8 text-center">
            {/* Icon */}
            <motion.div
              animate={{ scale: [1, 1.1, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-20 h-20 mx-auto mb-6 rounded-full bg-primary/20 flex items-center justify-center"
            >
              <Lock className="h-10 w-10 text-primary" />
            </motion.div>
            
            {/* Title */}
            <h2 className="text-3xl font-black uppercase tracking-tighter mb-2">
              Free Trial Ended
            </h2>
            
            <p className="text-muted-foreground mb-6">
              Your 7-day free trial has ended. Subscribe now to continue your 60-day transformation!
            </p>
            
            {/* Benefits */}
            <div className="bg-secondary/30 rounded-lg p-4 mb-6 text-left">
              <h3 className="font-bold text-sm uppercase tracking-wider text-primary mb-3">
                What You Get
              </h3>
              <ul className="space-y-2">
                {[
                  "Full 60-day workout program",
                  "AI-powered coaching messages",
                  "Beast Mode intensity booster",
                  "Progress tracking & analytics",
                  "Leaderboard access",
                  "Priority support"
                ].map((benefit, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm">
                    <CheckCircle className="h-4 w-4 text-accent flex-shrink-0" />
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* CTA */}
            <div className="space-y-3">
              <Link to="/pricing" className="block">
                <Button 
                  data-testid="subscribe-btn"
                  className="w-full bg-primary hover:bg-primary/90 uppercase font-bold tracking-widest py-6"
                >
                  <Crown className="mr-2 h-5 w-5" /> 
                  View Plans & Subscribe
                </Button>
              </Link>
            </div>
            
            {/* Trust badge */}
            <p className="mt-6 text-xs text-muted-foreground">
              <Flame className="h-3 w-3 inline mr-1" />
              Join 10,000+ transformations • Cancel anytime
            </p>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
